import { Navigate, useLocation } from "react-router-dom";
// HOOK
import useAuth from "app/hooks/useAuth";
import { useDispatch, useSelector } from "react-redux";
import { Fragment, useEffect } from "react";
import { getAuthUser } from "core/helper/localstorage";
import { loginAction } from "core/redux/account/account.action";

export default function AuthGuard({ children }) {
  const { isAuthenticated } = useAuth();
  const dispatch = useDispatch();
  const isLoggedIn = useSelector((state) => state?.account?.isLoggedIn);
  // console.log("isLoggedIn::", isLoggedIn);

  const { pathname } = useLocation();

  // useEffect(() => {
  //   const checkSession = () => {
  //     const authUser = getAuthUser();
  //     console.log("authUser::", authUser);

  //     if (authUser) {
  //       dispatch(loginAction(authUser));
  //     }
  //   };
  //   checkSession();
  // }, []);

  return (
    <Fragment>
      {isLoggedIn && <Fragment>{children}</Fragment>}{" "}
      {!isLoggedIn && (
        <Fragment>{<Navigate replace to="/session/signin" state={{ from: pathname }} />}</Fragment>
      )}
    </Fragment>
  );
}
